import React from "react";
import { Loader } from "@progress/kendo-react-indicators";

export default function LoadingScreen({
  themeColor = "warning",
  size = "large",
  type = "pulsing",
}) {
  return (
    <div className="loading">
      <Loader themeColor={themeColor} size={size} type={type} />
    </div>
  );
}
